import Vue from 'vue';
import Router from 'vue-router';
import home from '@/views/home'
Vue.use(Router);


import oms from './oms';



export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/',
      component: home,
      children: oms ,
		},
		{
			path: '/login',
      component: resolve => { require(['@/views/login'], resolve); },
		},
    {
      path: '/register',
      component: resolve => { require(['@/views/register'], resolve); },
    },
    
		
    // {
    //   path: '/school',
    //   component: resolve => { require(['../views/home.vue'], resolve); },
    //   // children: school,
    // },
	]
})
